import { makeUnselectable } from '@js/utils'
import { AssetManager } from '@js/loaders'

export class ImgCursor {
  private id: string
  private imgLeft: string | undefined
  private imgRight: string | undefined
  private imgPlay: string | undefined
  private imgPause: string | undefined
  cursor: HTMLImageElement | null = null

  private readonly imgMap: Record<string, () => string | undefined> = {
    left:  () => this.imgLeft,
    right: () => this.imgRight,
    play:  () => this.imgPlay,
    pause: () => this.imgPause,
  }

  constructor(id: string) {
    this.id = id

    const assets = AssetManager.getInstance()
    this.imgLeft  = assets.get('icons', 'left.svg')
    this.imgRight = assets.get('icons', 'right.svg')
    this.imgPlay  = assets.get('icons', 'play.svg')
    this.imgPause = assets.get('icons', 'pause.svg')

    this.setupCursor()
  }

  setupCursor(): void {
    this.cursor = document.createElement('img')
    this.cursor.id = this.id
    this.cursor.style.cssText = 'pointer-events:none; position:absolute; left:0; top:0; display:none'
    makeUnselectable(this.cursor)
    document.body.appendChild(this.cursor)

    document.addEventListener('mousemove', (e: MouseEvent) => {
      if (this.cursor) {
        this.cursor.style.left = `${e.pageX - 25}px`
        this.cursor.style.top  = `${e.pageY - 25}px`
      }
    })
  }

  setDisplay(state: boolean, keyword: string = ''): void {
    if (!this.cursor) return

    if (!state) {
      this.cursor.style.display = 'none'
      return
    }

    const src = this.imgMap[keyword]?.()
    if (src && this.cursor.src !== src) this.cursor.src = src
    this.cursor.style.display = 'block'
  }
}